const Loader = () => {
  return (
    <div className="size-10 rounded-full border-4 border-t-slate-700 animate-spin"></div>
  )
}
export default Loader